import React, { useState } from "react";
import { appName } from "../../../app.json";
import { useQuery, useMutation } from "react-apollo";
import { Helmet } from "react-helmet";
import Pagination from "../../../partials/pagination";
import { ParentSite as __q } from "../../../queries/parent-site.query";
import LoadingSpinner from "../../../partials/loading";
import ParentSiteList from "./parent-sitelist";
import NewParentSite from "./create";
import ParentSiteUpdate from "./update";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../util/app";
import { sendNotification } from "../../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../../event/model";
import { EventEmitter } from "../../../event/EventEmitter";

const ParentSite = ({ match }) => {
    const [page, setPage] = useState(1);
    const [limit] = useState(25);
    const [showNewModal, setShowNewModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showList, setShowList] = useState(true);
    const [current_item, setCurrentItem] = useState(null);

    const title = "Parent Sites";

    const { loading: fLoading, data: fData, fetchMore: fFetchMore, refetch } = useQuery(__q.QUERY.GETPARENTSITES, {
        variables: { page, limit },
        onError: (e) => toast.error(CleanMessage(e.message)),
        notifyOnNetworkStatusChange: true,
    });

    const [CreateParentSite, { loading: cLoading }] = useMutation(__q.MUTATION.NEWPARENTSITE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message, doc } = d.CreateParentSite;
            toast.success(message);
            setCurrentItem(doc);
            sendNotification(message, ACTION_TYPE.CREATE, EVENT_TARGET.PARENT_SITE);
        },
    });

    const [UpdateParentSite, { loading: uLoading }] = useMutation(__q.MUTATION.UPDATEPARENTSITE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.UpdateParentSite;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.UPDATE, EVENT_TARGET.PARENT_SITE);
        },
    });

    EventEmitter.subscribe(EVENT_TARGET.PARENT_SITE, () => refetch());
    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>
            <div className="row justify-content-center">
                {showList && (
                    <div className="col-md-12">
                        <div className="text-right">
                            <button
                                type="button"
                                className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success"
                                onClick={() => {
                                    setShowNewModal(true);
                                    setShowList(false);
                                    setShowUpdateModal(false);
                                }}
                            >
                                <i className="material-icons">person_add</i> New Parent Site
                            </button>
                        </div>

                        <div className="card">
                            <div className="card-head">
                                <header>Parent Site List</header>
                                <div className="tools">
                                    <a className="t-collapse btn-color fa fa-chevron-down" href="javascript:;"></a>
                                </div>
                            </div>

                            <div className="card-body">
                                <LoadingSpinner loading={fLoading} />
                                {!fLoading && (
                                    <ParentSiteList
                                        list={fData && fData.GetManyParentSite.docs}
                                        onUpdate={(p) => {
                                            setCurrentItem(p);
                                            setShowList(false);
                                            setShowNewModal(false);
                                            setShowUpdateModal(true);
                                        }}
                                    />
                                )}
                            </div>
                            {fData && (
                                <Pagination
                                    {...fData.GetManyParentSite}
                                    onPageClicked={(nextPage) =>
                                        setPage(nextPage) ||
                                        fFetchMore({
                                            variables: { page: nextPage },
                                            updateQuery: (prev, { fetchMoreResult }) => {
                                                if (!fetchMoreResult) return prev;
                                                return {
                                                    GetManyParentSite: fetchMoreResult.GetManyParentSite,
                                                };
                                            },
                                        })
                                    }
                                    length={fData.GetManyParentSite.docs.length}
                                />
                            )}
                        </div>
                    </div>
                )}
                {showNewModal && (
                    <div className="col-md-6 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setShowUpdateModal(false);
                                            setShowList(true);
                                            setShowNewModal(false);
                                        }}
                                        className="mdl-button mdl-button--icon margin-right-5"
                                    >
                                        <i className="fa fa-long-arrow-left"></i>
                                    </button>
                                    New Parent Site
                                </header>
                            </div>
                            <div className="card-body" id="bar-parent">
                                <LoadingSpinner loading={cLoading} />
                                <NewParentSite
                                    onCancel={() => {
                                        setShowUpdateModal(false);
                                        setShowList(true);
                                        setShowNewModal(false);
                                    }}
                                    onSubmit={async (item) => {
                                        const { name, email, tel } = item;
                                        await CreateParentSite({
                                            variables: { name, email, tel },
                                        });
                                        setShowNewModal(false);
                                        setShowUpdateModal(false);
                                        setShowList(true);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {showUpdateModal && (
                    <div className="col-md-6 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <span className="text-muted">Update </span> {current_item.name}
                                </header>
                            </div>
                            <div className="card-body" id="bar-parent">
                                <LoadingSpinner loading={uLoading} />
                                <ParentSiteUpdate
                                    currentItem={current_item}
                                    onCancel={() => {
                                        setShowNewModal(false);
                                        setShowUpdateModal(false);
                                        setShowList(true);
                                    }}
                                    onSubmit={async (item) => {
                                        await UpdateParentSite({
                                            variables: {
                                                id: current_item.id,
                                                model: item,
                                            },
                                        });
                                        setShowNewModal(false);
                                        setShowUpdateModal(false);
                                        setShowList(true);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ParentSite;
